const state = {
    ShowInitialData: false,
    ShowModalNoBtn: false,
    ShowErrorsCropStage: false,
};

const getters = {
    showInitialData: state => {
        return state.ShowInitialData;
    },
    showModalNoBtn: state => {
        return state.ShowModalNoBtn;
    },
    showErrorsCropStage: state => {
        return state.ShowErrorsCropStage;
    }
};


const mutations = {
    UpdateShowInitialData: (state, payload) => {
        state.ShowInitialData = payload;
    },
    UpdateShowModalNoBtn: (state, payload) => {
        state.ShowModalNoBtn = payload;
    },
    UpdateShowErrorsCropStage: (state, payload) => {
        state.ShowErrorsCropStage = payload;
    }
};


const actions = {
    UpdateShowInitialData ({ commit }, payload) {
        commit('UpdateShowInitialData', payload);
    },
    UpdateShowModalNoBtn ({ commit }, payload) {
        commit('UpdateShowModalNoBtn', payload);
    },
    UpdateShowErrorsCropStage ({ commit }, payload) {
        commit('UpdateShowErrorsCropStage', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};